import {
    Dialog,
    Divider,
    DialogContent,
    Grid,
    DialogActions,
    Button,
    Typography
} from "@mui/material"
import BaseDialogTitle from "src/components/dialog/BaseDialogTitle"
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {useState, useEffect, useCallback} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {ClientPhoneNumber, ClientPhoneNumberFields} from "src/types/client/clientData";
import {PhoneNumberSchema, RequiredSchema} from "../../../../../utils/validations";
import {LoaderBlockUI} from "../../../../../components/loader";
import {HttpClientPhone} from "../../../../../http/client/httpClient";
import {HttpCacheClient} from "../../../../../http/cache/client/httpCacheClient";
import {AsyncSelect, ControlledTextField} from "../../../../../components/forms";

interface DialogPhoneProps {
    open: boolean,
    onClose: () => void,
    phoneTitle: string,
    phone?: ClientPhoneNumber,
    clientId: number,
    onSubmitDialog: () => void
}



/*const useMaskPorCodigoDeArea = (codigoDeArea: any) => {
    const [mask, setMask] = useState<string>();

    const obtener_mask_string = (length: number) => {
        let mask;

        if (length === 2) mask = '0000 0000';
        else if (length === 3) mask = '000 0000';
        else mask = '000000';

        return mask;
    }

    useEffect(() => {
        codigoDeArea && setMask(obtener_mask_string(codigoDeArea.length));
    }, [codigoDeArea]);

    return { mask }
}*/

type PhoneFormData = {
    [ClientPhoneNumberFields.AreaCode]: string,
    [ClientPhoneNumberFields.PhoneNumber]: string,
    [ClientPhoneNumberFields.PhoneTypeCode]: number,
    [ClientPhoneNumberFields.Verified]: boolean
}


const DialogPhone = (props: DialogPhoneProps) => {
    const PhoneFormSchema = yup.object().shape({
        [ClientPhoneNumberFields.PhoneTypeCode]: RequiredSchema,
        [ClientPhoneNumberFields.AreaCode]: RequiredSchema,
        [ClientPhoneNumberFields.PhoneNumber]: PhoneNumberSchema,
    })
    const {
        control, handleSubmit, reset, watch
    } = useForm<PhoneFormData>({
        resolver: yupResolver(PhoneFormSchema),
        mode: 'onBlur',
        defaultValues:{
            ...props.phone
        }
    });
    
    //const { mask } = useMaskPorCodigoDeArea(watch(ClientPhoneNumberFields.AreaCode));
    
    const watchAreaCode = watch(ClientPhoneNumberFields.AreaCode)
    const watchPhoneType = watch(ClientPhoneNumberFields.PhoneTypeCode)
    const [isSaving, setSaving] = useState<boolean>(false);

    const loadPhoneTypes = useCallback(async () => {
        return await HttpCacheClient.getPhoneTypes();
    }, []);

    useEffect(() => {
        props.phone && reset(props.phone)
    }, [props.phone])
    
    const handleClose = () => {
        reset({
            [ClientPhoneNumberFields.PhoneNumber]: '',
            [ClientPhoneNumberFields.PhoneTypeCode]: 0,
            [ClientPhoneNumberFields.AreaCode]: '',
        })
        props.onClose()
    }
    const onSubmit = (data: PhoneFormData) => {
        setSaving(true);
        const phoneToInsert: PhoneFormData = {
            ...data, 
            [ClientPhoneNumberFields.Verified]: true
        }
        
        !props.phone?.id
            ? HttpClientPhone.insert(props.clientId, phoneToInsert as ClientPhoneNumber).then(() => {
                setSaving(false);
                handleClose()
                props.onSubmitDialog();
            })
            : HttpClientPhone.update(props.clientId, phoneToInsert as ClientPhoneNumber).then(() => {
                setSaving(false);
                handleClose()
                props.onSubmitDialog();
            });
    }
     

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth={'sm'} fullWidth>
            <BaseDialogTitle title={props.phoneTitle} onClose={handleClose} />
            <Divider />
            <DialogContent>
                <Grid container spacing={3} justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={4}>
                        <AsyncSelect loadOptions={loadPhoneTypes}
                                     control={control}
                                     name={ClientPhoneNumberFields.PhoneTypeCode}
                                     label="Tipo"
                                     required
                                     fullWidth
                        />
                    </Grid>
                    <Grid item xs={3.05}>
                        <ControlledTextField control={control} 
                                             name={ClientPhoneNumberFields.AreaCode}
                                             label="Cód. Área"
                                             size='small'
                                             fullWidth
                                             required
                        />
                    </Grid>
                    <Grid item xs={0.95} textAlign={'center'}>
                        {
                        watchPhoneType === 1 &&
                            <Typography fontSize={16}>15</Typography>
                        }
                    </Grid>
                    <Grid item xs={4}>
                        <ControlledTextField control={control}
                                             name={ClientPhoneNumberFields.PhoneNumber}
                                             label="Teléfono"
                                             required
                                             disabled={!watchAreaCode}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color={"primary"} variant={"contained"} onClick={handleSubmit(onSubmit)}>Guardar</Button>
            </DialogActions>
            { isSaving && <LoaderBlockUI/> }
        </Dialog>
    )
}


export default DialogPhone